import { Popover as AntdPopover, PopoverProps as AntPopoverProps } from "antd";
import { twMerge } from "tailwind-merge";

export type PopoverProps = AntPopoverProps;

export function Popover({ rootClassName, ...props }: PopoverProps) {
  return (
    <AntdPopover
      rootClassName={twMerge(
        rootClassName,
        "[&_.ant-popover-inner-content]:max-h-[270px]",
        "[&_.ant-popover-inner-content]:xl:max-h-[none]",
        "[&_.ant-popover-inner-content]:max-w-[300px]",
        "[&_.ant-popover-inner-content]:xl:max-w-[none]",
        "[&_.ant-popover-inner-content]:overflow-y-auto",
      )}
      {...props}
    />
  );
}
